export type ValidationRuleType = 'OnlyRequired' | 'Pattern' | 'Function' | 'Files' | 'PhoneNumber' | 'Email' | 'Numeric' | 'Text' | 'IBAN' | 'DateNotInPast';
export const ValidationRuleType = {
  OnlyRequired: 'OnlyRequired' as ValidationRuleType,
  Pattern: 'Pattern' as ValidationRuleType,
  Function: 'Function' as ValidationRuleType,
  Files: 'Files' as ValidationRuleType,
  PhoneNumber: 'PhoneNumber' as ValidationRuleType,
  Email: 'Email' as ValidationRuleType,
  Numeric: 'Numeric' as ValidationRuleType,
  Text: 'Text' as ValidationRuleType,
  IBAN: 'IBAN' as ValidationRuleType,
  DateNotInPast: 'DateNotInPast' as ValidationRuleType
};